import { Box, Container, styled as muiStyled } from "@mui/material";
interface BodyProps {
  overflow?: string;
}
export const Body = muiStyled(Box)<BodyProps>(({ theme, overflow }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 16,
  flex: 1,
  width: "100%",
  [theme.breakpoints.between("sm", "md")]: {
    padding: 24,
  },
  [theme.breakpoints.up("md")]: {
    paddingTop: 40,
    paddingBottom: 40,
    maxWidth: 800,
  },
  [theme.breakpoints.down("sm")]: {
    padding: 16,
  },
  ...(overflow && { overflow }),
}));

export const FormBody = muiStyled(Body)(({ theme }) => ({
  display: "flex",
  backgroundColor: theme.palette.background.paper,
  flexDirection: "column",
  flex: 1,
  overflow: "auto",
  width: "100%",
  minHeight: "618px",
  [theme.breakpoints.up("md")]: {
    padding: "56px 176px",
    borderRadius: 10,
    maxWidth: 800,
  },
  [theme.breakpoints.down("sm")]: {
    padding: "40px 16px",
    borderRadius: 0,
  },
  [theme.breakpoints.between("sm", "md")]: {
    padding: "40px 16px",
    borderRadius: 0,
  },
  gap: 16,
}));

interface ContentContainerProps {
  flex?: number;
}

export const ContentContainer = muiStyled(Container, {
  shouldForwardProp: (prop) => prop !== "flex",
})<ContentContainerProps>(({ flex }) => ({
  display: "flex",
  flexDirection: "column",
  maxWidth: 1200,
  alignItems: "center",
  alignContent: "center",
  gap: 40,
  flex: flex ?? "none",
}));

export const FormContentContainer = muiStyled(ContentContainer)(
  ({ theme, flex }) => ({
    flex: flex ?? "none",
    [theme.breakpoints.down("md")]: {
      flex: 1,
      backgroundColor: theme.palette.background.paper,
    },
    [theme.breakpoints.up("md")]: {
      padding: "40px 0px",
    },
  })
);
